import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'checkboxUnknown'];

  input() {
    if (this.inputTarget.value) {
      this.checkboxUnknownTarget.checked = false;
      this.inputTarget.required = true;
    }
  }

  toggle() {
    if (this.checkboxUnknownTarget.checked) {
      this.inputTarget.value = '';
      this.inputTarget.required = false;
    } else {
      this.inputTarget.required = true;
    }

    // Trigger input event to inform FormsController (for validation)
    this.inputTarget.dispatchEvent(new Event('input'));
  }
}
